import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotSites from './components/HotSites';
import LatestSites from './components/LatestSites';
import FAQSection from './components/FAQSection';
import { getRecentArticles } from '@/mocks/articles';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Home() {
  const recentArticles = getRecentArticles(4);

  const websiteSchema = {
    '@type': 'WebSite',
    name: '性福宝导航',
    url: 'https://greatkid.cn',
    description: '精选成人资源一站式导航平台，分类清晰、更新及时、安全可靠',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://greatkid.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@type': 'Organization',
    name: '性福宝导航',
    url: 'https://greatkid.cn',
    description: '精选成人资源一站式导航平台',
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '性福宝导航 - 精选成人资源一站式导航平台',
          description: '性福宝导航是专为成人用户打造的一站式资源导航平台，汇聚海量精选成人内容、娱乐资源及相关服务链接',
          url: 'https://greatkid.cn',
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <HotSites />

        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  精品文章
                </h2>
                <p className="text-sm text-foreground-600">
                  平台评测、使用技巧、安全指南等原创内容
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {recentArticles.map((article) => {
                const cat = categories.find((c) => c.slug === article.categorySlug);
                return (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-40 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-[11px] text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded">
                          {cat?.name || '综合'}
                        </span>
                        <span className="text-[11px] text-foreground-400">{article.readTime}</span>
                      </div>
                      <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 flex items-center justify-between">
                        <span className="text-[11px] text-foreground-400">{article.publishDate}</span>
                        <span className="text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                          阅读全文 <i className="ri-arrow-right-line text-[10px]"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        <LatestSites />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}